import { Realty, services, dataServices } from '@ambita/ambita-components-core';
import { ApiComplaint } from '../../../typings/CadastreReport';

const util = services.util;
const xhr = dataServices.xhr;

function transformComplaints(complaintsData: Realty.ApiResponse) {
  if (complaintsData.items && complaintsData.items.length > 0) {
    const complaints: ApiComplaint[] = complaintsData.items;
    const retObject: any = {
      complaints: []
    };

    complaints.forEach((complaint: ApiComplaint) => {
      const tmpObj: any = util.pick(complaint, [
        'registeredDate',
        'complaintConcerns'
      ]);

      xhr.getJSON(complaint.links.cadastres.href)
        .then((result) => {
          if (result.items && result.items.length > 0) {
            tmpObj.cadastres = result.items;
          }
        });

      retObject.complaints.push(tmpObj);
    });
    retObject.complaints = retObject.complaints.reverse();
    return retObject;
  }
}

export default transformComplaints;
